const sanitize = (value: string) =>
  value.trim().toUpperCase().replace(/[^A-Z0-9]+/g, "_").replace(/^_+|_+$/g, "");

export const buildExportName = (...parts: Array<string | number | undefined | null>): string =>
  parts
    .filter((part) => part !== undefined && part !== null && `${part}`.trim() !== "")
    .map((part) => sanitize(`${part}`))
    .filter(Boolean)
    .join("_");
